// extracted by mini-css-extract-plugin
module.exports = {"box":"Files_box__zpjmp","opened":"Files_opened__IbOUn","title":"Files_title__fDUho","main":"Files_main__3-ndz","link":"Files_link__20in3"};